/**
 * Copia mínima de lo que devuelve GET /api/packs para Pack Japón.
 * Se usa si la API no responde (o devuelve []), para que invitados y
 * usuarios vean la misma tarjeta de marketing. Mantener alineado con
 * `guia-backend/data/packs.js` → japon.
 */
const PACK_JAPON_PUBLIC_FALLBACK = {
	id: "japon",
	title: "Pack Japón",
	subtitle: "Guía Tokio + Kioto + Osaka · Stickers · Páginas extra",
	price: 5.99,
	currency: "EUR",
	includedInPro: true,
	marketing: {
		heroImage: "/pack-japon-hero.png",
		accent: "#ef4444",
		tagline: "Todo lo que necesitas para tu viaje a Japón",
		digitalOnlyNotice:
			"100% digital: acceso online. No enviamos nada por correo; el PDF de stickers lo imprimes tú si quieres.",
		highlights: [
			{
				icon: "guide",
				title: "Guía de Tokio + Kioto + Osaka",
				description:
					"Las tres ciudades juntas en una sola guía editable con todo el itinerario.",
			},
			{
				icon: "stickers",
				title: "Stickers personalizables + PDF imprimible",
				description:
					"15 stickers de Japón con tu nombre. Descarga el PDF listo para imprimir y recortar.",
			},
			{
				icon: "stickerPack",
				title: "Pack de stickers de Japón",
				description:
					"Acceso completo al catálogo de stickers de Japón para tu guía.",
			},
			{
				icon: "pages",
				title: "15 páginas extra",
				description:
					"Para tus propias notas, mapas y planes dentro del editor.",
			},
		],
	},
	entitlements: {
		prebuiltGuides: ["japon"],
		customStickerCountries: ["japan"],
		stickerCollections: ["japan", "japan-label"],
		extraPagesPerGuide: { japon: 15 },
	},
	replacesStandaloneSaleFor: ["japon"],
	isOwned: false,
	isUnlockedByPro: false,
	hasAccess: false,
	isAvailableForPurchase: true,
};

export default PACK_JAPON_PUBLIC_FALLBACK;
